module.exports = __webpack_public_path__ + "media/images/app/homepage/refer-friend-d2a33967c026840025be9aaba08d0697.webp";